/* tslint:disable */
/* eslint-disable */
import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiConfiguration, ApiConfigurationParams } from './api-configuration';

import { BasketService } from './services/basket.service';
import { CategoryService } from './services/category.service';
import { InventoryService } from './services/inventory.service';
import { InventoryInService } from './services/inventory-in.service';
import { InventoryOutService } from './services/inventory-out.service';
import { ItemsService } from './services/items.service';
import { OrderDetailsService } from './services/order-details.service';
import { OrdersService } from './services/orders.service';
import { OrderStakeholderService } from './services/order-stakeholder.service';
import { ReportsService } from './services/reports.service';

/**
 * Module that provides all services and configuration.
 */
@NgModule({
  imports: [],
  exports: [],
  declarations: [],
  providers: [
    BasketService,
    CategoryService,
    InventoryService,
    InventoryInService,
    InventoryOutService,
    ItemsService,
    OrderDetailsService,
    OrdersService,
    OrderStakeholderService,
    ReportsService,
    ApiConfiguration
  ],
})
export class PNApiModule {
  static forRoot(params: ApiConfigurationParams): ModuleWithProviders<PNApiModule> {
    return {
      ngModule: PNApiModule,
      providers: [
        {
          provide: ApiConfiguration,
          useValue: params
        }
      ]
    }
  }

  constructor( 
    @Optional() @SkipSelf() parentModule: PNApiModule,
    @Optional() http: HttpClient
  ) {
    if (parentModule) {
      throw new Error('PNApiModule is already loaded. Import in your base AppModule only.');
    }
    if (!http) {
      throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
      'See also https://github.com/angular/angular/issues/20575');
    }
  }
}
